import { useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { useDarkModeContext } from '../../../DarkModeContext/useDarkModeContext';
import { usePDPSliceSelectorContext } from '@/hooks/shared/usePDPSliceSelector';
import { useSliceSectionSelector } from '@/redux/slices/pdpSlice';

export interface BaseBoxStickyButtonProps {
  children: React.ReactNode;
  sticky?: boolean;
}

const StickyButton: React.FC<BaseBoxStickyButtonProps> = ({ children, sticky }) => {
  const { sliceName } = usePDPSliceSelectorContext();

  const ref = useRef<HTMLDivElement>(null);
  const [loaded, setLoaded] = useState(false);
  const isFooterInView = useSliceSectionSelector(sliceName, s => s.isFooterInView);
  const isSiteNavFooterInView = useSelector((state: RootState) => state.page.footerVisible);
  const darkmodeContext = useDarkModeContext();
  const isDarkMode = darkmodeContext?.isDarkMode ?? false;

  useEffect(() => {
    if (sticky) {
      if (!loaded) {
        setLoaded(true);
      }
    }
  }, [loaded, sticky]);

  const containerClasses = classnames('container fixed inset-x-0 bottom-0 z-panel pb-6 pt-8', {
    'animate-slideInUp': sticky && !isFooterInView && !isSiteNavFooterInView,
    'animate-slideOutDown': !sticky || isFooterInView || isSiteNavFooterInView,
    'bg-darkmode-sticky-button-gradient': isDarkMode,
    'bg-sticky-button-gradient': !isDarkMode
  });

  return loaded ? (
    <div ref={ref} className={containerClasses}>
      {children}
    </div>
  ) : null;
};

export default StickyButton;
